import type { FileMap } from '~/lib/stores/files';
import { createScopedLogger } from '~/utils/logger';

export const logger = createScopedLogger('SupabaseStoreUtils');

export function diffFileMap(before: FileMap, after: FileMap) {
  const beforeFiles = new Set(Object.keys(before));
  const afterFiles = new Set(Object.keys(after));

  return {
    added: [...afterFiles].filter((filePath) => !beforeFiles.has(filePath)),
    removed: [...beforeFiles].filter((filePath) => !afterFiles.has(filePath)),
  };
}
